/**
 * Policy enforcement: employees whose HOME country (per the Amazonian profile)
 * is in this list must return their old device to receive a new one. Derived
 * from the Amazonian's home country, never from the shipping address, so a
 * user cannot bypass the rule by changing the shipping destination.
 */
export const RETURN_DEVICE_COUNTRIES = ["CRI", "IND"];

/** IT Portal search for AEA browser extension refresh instructions. */
export const AEA_REFRESH_GUIDE_URL =
  "https://my.it.a2z.com/search?query=refresh%20aea&filters=ITPortal&language=en";
